// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-52a7fc28],.products-grid[data-v-52a7fc28]{display:none}@media(min-width:1024px){.products-grid[data-v-52a7fc28]{display:grid;grid-auto-rows:auto;grid-template-columns:repeat(2,minmax(282px,1fr));max-width:587px;grid-gap:24px}.products-grid__item[data-v-52a7fc28]{margin-bottom:6px}}[data-v-52a7fc28] .recipe-card__title a{font-weight:var(--font-weight--normal)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
